export const SMALLESTUNIT = 100000000;
export const totallimit = 10000000000000000;

/** Grid is 30 cols. Place Order +1 col (~20%); chart −1 col. Order book unchanged. */
const PLACE_ORDER_W = 6;
const ORDER_BOOK_W = 6;
const ORDER_BOOK_X = PLACE_ORDER_W;
const CHART_W = 12;
const CHART_X = ORDER_BOOK_X + ORDER_BOOK_W;
const WATCHLIST_X = CHART_X + CHART_W;
const WATCHLIST_W = 6;
export const TRADE_LAYOUT_VERSION = 4;

export const OPEN_ORDER_GRID_H = 16.8;
export const ACCOUNTS_GRID_H = 13.8;

const PANEL_HEIGHT_TARGETS = {
  lg: {
    OrderBook: 28.1,
    OpenOrder: OPEN_ORDER_GRID_H,
    Accounts: ACCOUNTS_GRID_H,
    MarketTrades: 13.1,
  },
  md: {
    OrderBook: 25.2,
    OpenOrder: OPEN_ORDER_GRID_H,
    Accounts: 11.5,
    MarketTrades: 11.7,
  },
};

const PANEL_LEGACY_HEIGHTS = {
  OpenOrder: [11.8, 12.8, 13.5, 14.5, 27],
  Accounts: { lg: [10.8, 14.8, 15.8, 18.8, 21], md: [8.5, 12.5, 13.5, 16.5, 18] },
  OrderBook: { lg: [32, 33, 34], md: [29, 30, 31] },
  MarketTrades: { lg: [18, 19, 20], md: [15, 16] },
};

export const DEFAULT_LAYOUT = {
  lg: [
    {
      i: "BuySellTab",
      x: 0,
      y: 0,
      h: 5.1,
      w: PLACE_ORDER_W,
      minW: 3,
      minH: 1,
      isResizable: true,
      resizeHandles: ["se"],
    },
    {
      i: "Accounts",
      x: 0,
      y: 5.1,
      h: ACCOUNTS_GRID_H,
      w: PLACE_ORDER_W,
      minW: 4,
      minH: 5,
      resizeHandles: ["se"],
      isResizable: true,
    },
    {
      i: "OrderBook",
      x: ORDER_BOOK_X,
      y: 0,
      h: PANEL_HEIGHT_TARGETS.lg.OrderBook,
      w: ORDER_BOOK_W,
      minW: 3,
      minH: 2,
      resizeHandles: ["se"],
      isResizable: true,
    },
    {
      i: "TradeChart",
      x: CHART_X,
      y: 0,
      h: 16.4,
      w: CHART_W,
      minW: 6,
      minH: 6,
      resizeHandles: ["se"],
      isResizable: true,
    },
    {
      i: "OpenOrder",
      x: CHART_X,
      y: 5,
      h: OPEN_ORDER_GRID_H,
      w: CHART_W,
      minW: 8,
      minH: 6,
      resizeHandles: ["se"],
      isResizable: true,
    },
    {
      i: "WatchList",
      x: WATCHLIST_X,
      y: 0,
      h: 15.1,
      w: WATCHLIST_W,
      minW: 3,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: true,
    },

    {
      i: "MarketTrades",
      x: WATCHLIST_X,
      y: 14,
      h: PANEL_HEIGHT_TARGETS.lg.MarketTrades,
      w: WATCHLIST_W,
      minW: 3,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: true,
    },
  ],
  md: [
    {
      i: "BuySellTab",
      x: 0,
      y: 0,
      h: 11,
      w: PLACE_ORDER_W,
      minW: 3,
      minH: 1,
      isResizable: true,
      resizeHandles: ["se"],
    },
    {
      i: "Accounts",
      x: 0,
      y: 11,
      h: PANEL_HEIGHT_TARGETS.md.Accounts,
      w: PLACE_ORDER_W,
      minW: 4,
      minH: 5,
      resizeHandles: ["se"],
      isResizable: true,
    },
    {
      i: "OrderBook",
      x: ORDER_BOOK_X,
      y: 0,
      h: PANEL_HEIGHT_TARGETS.md.OrderBook,
      w: ORDER_BOOK_W,
      minW: 3,
      minH: 2,
      resizeHandles: ["se"],
      isResizable: true,
    },
    {
      i: "TradeChart",
      x: CHART_X,
      y: 0,
      h: 13.5,
      w: CHART_W,
      minW: 6,
      minH: 6,
      resizeHandles: ["se"],
      isResizable: true,
    },
    {
      i: "OpenOrder",
      x: CHART_X,
      y: 5,
      h: OPEN_ORDER_GRID_H,
      w: CHART_W,
      minW: 8,
      minH: 6,
      resizeHandles: ["se"],
      isResizable: true,
    },
    {
      i: "WatchList",
      x: WATCHLIST_X,
      y: 0,
      h: 13.6,
      w: WATCHLIST_W,
      minW: 3,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: true,
    },

    {
      i: "MarketTrades",
      x: WATCHLIST_X,
      y: 14,
      h: PANEL_HEIGHT_TARGETS.md.MarketTrades,
      w: WATCHLIST_W,
      minW: 3,
      minH: 1,
      resizeHandles: ["se"],
      isResizable: true,
    },
  ],
};

/** Soft defaults only — never overwrite user x/y/w/h (that snaps panels after drag). */
const TRADE_ITEM_DEFAULTS = {
  BuySellTab: { minW: 3, minH: 1, isResizable: true, resizeHandles: ["se"] },
  Accounts: { minW: 4, minH: 5, isResizable: true, resizeHandles: ["se"] },
  OrderBook: { minW: 3, minH: 2, isResizable: true, resizeHandles: ["se"] },
  TradeChart: { minW: 6, minH: 6, isResizable: true, resizeHandles: ["se"] },
  OpenOrder: { minW: 8, minH: 6, isResizable: true, resizeHandles: ["se"] },
  WatchList: { minW: 3, minH: 1, isResizable: true, resizeHandles: ["se"] },
  MarketTrades: { minW: 3, minH: 1, isResizable: true, resizeHandles: ["se"] },
};

const isLegacyGridHeight = (h, legacyHeights = []) => {
  const value = Number(h);
  if (!Number.isFinite(value)) return false;
  return legacyHeights.some((legacyHeight) => Math.abs(value - legacyHeight) < 0.05);
};

const migratePanelHeight = (item, breakpoint, panelKey) => {
  const targets = PANEL_HEIGHT_TARGETS[breakpoint] ?? PANEL_HEIGHT_TARGETS.lg;
  const targetH = targets[panelKey];
  if (!Number.isFinite(targetH)) return item;

  const legacyConfig = PANEL_LEGACY_HEIGHTS[panelKey];
  const legacyHeights = Array.isArray(legacyConfig)
    ? legacyConfig
    : legacyConfig?.[breakpoint] ?? [];

  const currentH = Number(item.h);
  const wasLegacy = isLegacyGridHeight(item.h, legacyHeights);
  const wasViewportStretch =
    (panelKey === "OrderBook" || panelKey === "MarketTrades") &&
    Number.isFinite(currentH) &&
    currentH > targetH + 0.5;

  if (!wasLegacy && !wasViewportStretch) {
    return item;
  }

  return { ...item, h: targetH };
};

const patchBreakpointItems = (items, breakpoint = "lg") => {
  if (!items?.length) return items;

  const migratedItems = items.map((item) => {
    if (item.i === "OpenOrder") return migratePanelHeight(item, breakpoint, "OpenOrder");
    if (item.i === "Accounts") return migratePanelHeight(item, breakpoint, "Accounts");
    if (item.i === "OrderBook") return migratePanelHeight(item, breakpoint, "OrderBook");
    if (item.i === "MarketTrades") return migratePanelHeight(item, breakpoint, "MarketTrades");
    return { ...item };
  });

  return migratedItems.map((item) => {
    const defaults = TRADE_ITEM_DEFAULTS[item.i];
    if (!defaults) return { ...item };

    const patched = {
      ...defaults,
      ...item,
      minW: item.minW ?? defaults.minW,
      minH: item.minH ?? defaults.minH,
      isResizable: item.isResizable ?? defaults.isResizable,
      resizeHandles: item.resizeHandles ?? defaults.resizeHandles,
    };

    return patched;
  });
};

/** Ensure layout items are plain mutable objects with safe defaults (keeps user positions). */
export const normalizeTradeGridLayout = (layout) => {
  if (!layout?.lg?.length && !layout?.md?.length) {
    // Never return DEFAULT_LAYOUT by reference — RTK freezes state objects.
    return JSON.parse(JSON.stringify(DEFAULT_LAYOUT));
  }
  return {
    ...layout,
    lg: patchBreakpointItems(layout.lg, "lg"),
    md: patchBreakpointItems(layout.md, "md"),
  };
};

/** @deprecated use normalizeTradeGridLayout */
export const migrateTradeGridWidths = normalizeTradeGridLayout;

export const DEFAULT_EMPTY_LAYOUT = {
  lg: [],
  md: [],
};
export const LAYOUT_LIST = [];
// export const LAYOUT_LIST = [
//   {
//     workspace: 'Workspace 1',
//     disable: false,
//     active: true,
//     layout: {
//       lg: [
//         {
//           i: "BuySellTab",
//           x: 0,
//           y: 0,
//           h: 17.2,
//           w: 5,
//           minW: 3,
//           minH: 1,
//           isResizable: true,
//           resizeHandles: ["se"],
//         },
//         {
//           i: "Accounts",
//           x: 0,
//           y: 11,
//           h: 10.8,
//           w: 5,
//           minW: 4,
//           minH: 5,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OrderBook",
//           x: 5,
//           y: 0,
//           h: 28.1,
//           w: 6,
//           minW: 3,
//           minH: 2,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "TradeChart",
//           x: 11,
//           y: 0,
//           h: 16.4,
//           w: 13,
//           minW: 6,
//           minH: 6,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OpenOrder",
//           x: 11,
//           y: 5,
//           h: 11.8,
//           w: 13,
//           minW: 8,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "WatchList",
//           x: 37,
//           y: 0,
//           h: 15.1,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },

//         {
//           i: "MarketTrades",
//           x: 37,
//           y: 11,
//           h: 13.1,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//       ],
//       md: [
//         {
//           i: "BuySellTab",
//           x: 0,
//           y: 0,
//           h: 16.7,
//           w: 5,
//           minW: 3,
//           minH: 1,
//           isResizable: true,
//           resizeHandles: ["se"],
//         },
//         {
//           i: "Accounts",
//           x: 0,
//           y: 11,
//           h: 8.5,
//           w: 5,
//           minW: 4,
//           minH: 5,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OrderBook",
//           x: 5,
//           y: 0,
//           h: 25.2,
//           w: 6,
//           minW: 3,
//           minH: 2,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "TradeChart",
//           x: 11,
//           y: 0,
//           h: 13.5,
//           w: 13,
//           minW: 6,
//           minH: 6,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OpenOrder",
//           x: 11,
//           y: 5,
//           h: 11.8,
//           w: 13,
//           minW: 8,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "WatchList",
//           x: 37,
//           y: 0,
//           h: 13.6,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },

//         {
//           i: "MarketTrades",
//           x: 37,
//           y: 11,
//           h: 11.7,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//       ],
//     }
//   },
//   {
//     workspace: 'Workspace 2',
//     disable: true,
//     active: false,
//     layout: {
//       lg: [
//         {
//           i: "BuySellTab",
//           x: 0,
//           y: 0,
//           h: 17.2,
//           w: 5,
//           minW: 3,
//           minH: 1,
//           isResizable: true,
//           resizeHandles: ["se"],
//         },
//         {
//           i: "Accounts",
//           x: 0,
//           y: 11,
//           h: 10.8,
//           w: 5,
//           minW: 4,
//           minH: 5,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OrderBook",
//           x: 5,
//           y: 0,
//           h: 28.1,
//           w: 6,
//           minW: 3,
//           minH: 2,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "TradeChart",
//           x: 11,
//           y: 0,
//           h: 16.4,
//           w: 13,
//           minW: 6,
//           minH: 6,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OpenOrder",
//           x: 11,
//           y: 5,
//           h: 11.8,
//           w: 13,
//           minW: 8,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "WatchList",
//           x: 37,
//           y: 0,
//           h: 15.1,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },

//         {
//           i: "MarketTrades",
//           x: 37,
//           y: 11,
//           h: 13.1,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//       ],
//       md: [
//         {
//           i: "BuySellTab",
//           x: 0,
//           y: 0,
//           h: 16.7,
//           w: 5,
//           minW: 3,
//           minH: 1,
//           isResizable: true,
//           resizeHandles: ["se"],
//         },
//         {
//           i: "Accounts",
//           x: 0,
//           y: 11,
//           h: 8.5,
//           w: 5,
//           minW: 4,
//           minH: 5,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OrderBook",
//           x: 5,
//           y: 0,
//           h: 25.2,
//           w: 6,
//           minW: 3,
//           minH: 2,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "TradeChart",
//           x: 11,
//           y: 0,
//           h: 13.5,
//           w: 13,
//           minW: 6,
//           minH: 6,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OpenOrder",
//           x: 11,
//           y: 5,
//           h: 11.8,
//           w: 13,
//           minW: 8,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "WatchList",
//           x: 37,
//           y: 0,
//           h: 13.6,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },

//         {
//           i: "MarketTrades",
//           x: 37,
//           y: 11,
//           h: 11.7,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//       ],
//     }
//   },
//   {
//     workspace: 'Workspace 3',
//     disable: true,
//     active: false,
//     layout: {
//       lg: [
//         {
//           i: "BuySellTab",
//           x: 0,
//           y: 0,
//           h: 17.2,
//           w: 5,
//           minW: 3,
//           minH: 1,
//           isResizable: true,
//           resizeHandles: ["se"],
//         },
//         {
//           i: "Accounts",
//           x: 0,
//           y: 11,
//           h: 10.8,
//           w: 5,
//           minW: 4,
//           minH: 5,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OrderBook",
//           x: 5,
//           y: 0,
//           h: 28.1,
//           w: 6,
//           minW: 3,
//           minH: 2,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "TradeChart",
//           x: 11,
//           y: 0,
//           h: 16.4,
//           w: 13,
//           minW: 6,
//           minH: 6,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OpenOrder",
//           x: 11,
//           y: 5,
//           h: 11.8,
//           w: 13,
//           minW: 8,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "WatchList",
//           x: 37,
//           y: 0,
//           h: 15.1,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },

//         {
//           i: "MarketTrades",
//           x: 37,
//           y: 11,
//           h: 13.1,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//       ],
//       md: [
//         {
//           i: "BuySellTab",
//           x: 0,
//           y: 0,
//           h: 16.7,
//           w: 5,
//           minW: 3,
//           minH: 1,
//           isResizable: true,
//           resizeHandles: ["se"],
//         },
//         {
//           i: "Accounts",
//           x: 0,
//           y: 11,
//           h: 8.5,
//           w: 5,
//           minW: 4,
//           minH: 5,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OrderBook",
//           x: 5,
//           y: 0,
//           h: 25.2,
//           w: 6,
//           minW: 3,
//           minH: 2,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "TradeChart",
//           x: 11,
//           y: 0,
//           h: 13.5,
//           w: 13,
//           minW: 6,
//           minH: 6,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "OpenOrder",
//           x: 11,
//           y: 5,
//           h: 11.8,
//           w: 13,
//           minW: 8,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//         {
//           i: "WatchList",
//           x: 37,
//           y: 0,
//           h: 13.6,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },

//         {
//           i: "MarketTrades",
//           x: 37,
//           y: 11,
//           h: 11.7,
//           w: 6,
//           minW: 3,
//           minH: 1,
//           resizeHandles: ["se"],
//           isResizable: true,
//         },
//       ],
//     }
//   }
// ];
// export const GRID_LAYOUT = LAYOUT_LIST[0];
export const SELECTED_LAYOUT = []//LAYOUT_LIST.filter(o => o.active);
export const GRID_LAYOUT = {}//SELECTED_LAYOUT[0].layout;
export const CURRENT_WORKSPACE = ''//SELECTED_LAYOUT[0].workspace.replace(/ /g, '_');

export const FONT_LAYOUT = {
  openOrder: 11,
  tableHead: 11,
  tableBody: 11,
  tickerHead: 13,
  tickerArrow: 15,
  tickerPrice: 12,
  minFont: 9,
};
